export default "__VITE_ASSET__zkJrHH9y__"